import { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { FaCopy } from 'react-icons/fa'; // Import the clipboard icon
import { toast } from 'react-toastify';
import { handleNumericFloatInput } from '../../../utils/utils';

const PriceCalculatorModal = ({ show, onHide }) => {


  const [buyingPrice, setBuyingPrice] = useState('');
  const [quantity, setQuantity] = useState('');

  // Calculate buying price per unit without rounding
  const buyingPricePerUnit = parseFloat(buyingPrice) / parseFloat(quantity) || 0;

  // Function to copy buying price per unit to clipboard
  const copyToClipboard = () => {
    toast.success('Price copied to clipboard!');
    navigator.clipboard.writeText(buyingPricePerUnit.toFixed(2).toString());
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Price Calculator</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Buying Price</Form.Label>
            <Form.Control
              type="text"
              value={buyingPrice}
              onChange={(e) => handleNumericFloatInput(e, setBuyingPrice)}
              placeholder="Enter buying price"
              min={0}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Quantity</Form.Label>
            <Form.Control
              type="text"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              placeholder="Enter quantity"
              min={0}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Buying Price Per Unit</Form.Label>
            <div className="d-flex align-items-center">
              <Form.Control
                type="text"
                value={buyingPricePerUnit.toFixed(2)}
                readOnly
                placeholder="Calculated buying price per unit"
                disabled
              />
              <FaCopy
                className="ms-2 success"
                size={25}
                style={{ cursor: 'pointer', color: '#61bd5e' }} // Make the icon greenish
                onClick={copyToClipboard}
                title="Copy Price"
              />
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
      </Modal.Footer>
    </Modal>
  );
};

export default PriceCalculatorModal;